import { Component, OnInit, Input, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { first } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IPanelSettings } from 'src/app/shared/interface/panel-settings';
import { IButtonData } from 'src/app/shared/components/button/button.component';
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';


interface FaqPanelData {
  title?: IUProperty<string>;
  capitalizeTitle?: IUProperty<boolean>;
  description?: IUProperty<string>;
  items?: IUProperty<IFAQItem[]>;
  panelSettings?: IPanelSettings;

  titleStyleSettings?: ITitleStyleSettings;
  rteStyleSettings?: IRteStyleSettings;
}
interface IFAQItem {
  answer: IUProperty<any>;
  question: IUProperty<string>;
  link?: IUProperty<IButtonData>;
  state?: string;
  anchor?: IUProperty<string>;
}

enum AccordionItemState {
  opened = 'opened',
  closed = 'closed'
}

@Component({
  selector: 'app-faq-panel',
  templateUrl: './faq-panel.component.html',
  styleUrls: ['./faq-panel.component.less'],
  animations: [
    trigger('animation', [
      state('opened', style({
        height: '*',
        opacity: '1'
      })),
      state('closed', style({
        height: '0',
        opacity: '0',
        paddingBottom: '0',
        paddingTop: '0'
      })),
      transition('* => *', [animate('.2s')])
    ])
  ]
})
export class FaqPanelComponent implements OnInit {
  @Input() data: FaqPanelData;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;
  accordionItemState = AccordionItemState;
  ready = false;

  @ViewChildren('iconTrigger') iconTriggers: QueryList<ElementRef<HTMLElement>>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private viewportScroller: ViewportScroller,
  ) { }

  ngOnInit()
  {
    this.data.items.value = this.data.items.value.map(i => {
      i.state = AccordionItemState.closed;

      return i;
    });

    this.route.fragment
      .pipe(first())
      .subscribe((fragment: string) => {
        this.handleInitialAnchor(fragment);
      });
  }

  ngAfterViewInit(): void {
    this.iconTriggers && this.iconTriggers.forEach(icon => {
      if (icon.nativeElement 
        && this.data.panelSettings 
        && this.data.panelSettings.theme.value 
        && this.data.panelSettings.theme.value.backgroundColor
        && (this.data.panelSettings.theme.value.backgroundColor.toLocaleLowerCase() === '#fff' || this.data.panelSettings.theme.value.backgroundColor.toLocaleLowerCase() === '#ffffff')
      ) {
        icon.nativeElement.style.color = 'var(--text-color)';
      }
    })

    if (this.titleEl && this.titleEl.nativeElement && this.data && this.data.capitalizeTitle && this.data.capitalizeTitle.value) {
      this.titleEl.nativeElement.style.textTransform = 'uppercase';
    }
    applyTitleSettings(this.data, this.titleEl);
    applyRteSettings(this.data, this.descriptionEl);
  }

  handleToggleItem(item: any)
  {
    this.ready = true;
    if (item.state === AccordionItemState.opened)
    {
      item.state = this.accordionItemState.closed;
      this.router.navigate([], {relativeTo: this.route});
    } else {
      item.state = this.accordionItemState.opened;
      //this.router.navigate([], {
      //  relativeTo: this.route,
      //  fragment: item.anchor.value
      //});
    }
  }

  private handleInitialAnchor(anchor: string)
  {
    if (!anchor) return;

    try {
      let target = this.data.items.value.find(i => i.anchor.value === anchor);
      this.ready = true;
      target.state = AccordionItemState.opened;

    } catch (err) {
    } finally {
      setTimeout(() => {
        this.viewportScroller.scrollToAnchor(anchor);
      }, 300);
    }
  }
}
